import React from 'react';
import { FaFacebookF, FaLinkedinIn } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { GiFairyWings } from 'react-icons/gi'; 
import './PatronTrustee.css';

import trustee1 from '../../../assets/home/onkar-singh.jpg';
import trustee2 from '../../../assets/home/shiv-ji-singh.jpg';
import trustee3 from '../../../assets/home/ummedsingh.jpg';
import trustee4 from '../../../assets/home/arjunsinghji.jpg';

const trusteesData = [
  { id: 1, name: "Thakur Onkar Singh Babra IAS(Retd.)", post: "Trustee, Rajput Shiksha Kosh.", img: trustee1 },
  { id: 2, name: "Col. Shivji Singh", post: "Trustee, Rajput Shiksha Kosh.", img: trustee2 },
  { id: 3, name: "Col. Ummed Singh Rathore", post: "Trustee, Rajput Shiksha Kosh.", img: trustee3 },
  { id: 4, name: "Shri Arjun Singh Jhotra", post: "Trustee, Rajput Shiksha Kosh.", img: trustee4 },
];

const PatronTrustee = () => {
  return (
    <section className="patron-trustee-component-section">
      <div className="patron-trustee-component-container">
        
        {/* --- HEADER & DIVIDER --- */}
        <div className="patron-trustee-component-header">
          <h2 className="patron-trustee-component-title">Patron Trustee - Rajput Shiksha Kosh</h2>
          <div className="patron-trustee-component-divider">
            <span className="patron-trustee-component-line"></span>
            <GiFairyWings className="patron-trustee-component-icon" />
            <span className="patron-trustee-component-line"></span>
          </div>
        </div>

        {/* --- TRUSTEE GRID --- */}
        <div className="patron-trustee-component-grid">
          {trusteesData.map((trustee) => (
            <div className="patron-trustee-component-card" key={trustee.id}>
              
              <div className="patron-trustee-component-img-wrapper">
                <img 
                  src={trustee.img} 
                  alt={trustee.name} 
                  className="patron-trustee-component-img" 
                />
              </div>

              <div className="patron-trustee-component-info">
                <h3 className="patron-trustee-component-name">{trustee.name}</h3>
                <p className="patron-trustee-component-post">{trustee.post}</p>
              </div>

            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default PatronTrustee;